import { useQuery } from '@tanstack/react-query'

import { type MarketplaceProductCategory, type MarketplaceProductsResponse } from 'components/marketplace/shared/types'
import { type GrapeMoney, type MoneyAmount } from 'types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export const useGetMarketplaceProducts = () => useQuery<MarketplaceProductsResponse, GrapeAPIErrorType>({
  queryKey: ['marketplace'],
  queryFn: async () => {
    const response = await fetchWithHeaders('/api/web/marketplace/products')
    if (!response.ok) {
      const errorJson = await response.json()
      throw GrapeAPIError({
        status: response.status,
        message: errorJson.message,
        errors: errorJson.errors,
      })
    }
    return response.json()
  },
  select: (data) => {
    const toMoneyAmount = (money?: GrapeMoney | null): MoneyAmount | null => {
      if (!money) return null

      return {
        value: (money.subunits / 100).toString(),
        currency: money.currency,
      }
    }

    const transformedData = data.data.map(product => ({
      ...product,
      // TODO(yousef): fix this API-side
      categories: product.categories.map(category => category.replace(/\\u0026/g, '&') as MarketplaceProductCategory),
      base_price_money_amount: toMoneyAmount(product.base_price),
      discounted_price_money_amount: toMoneyAmount(product.discounted_price),
    }))
    return { ...data, data: transformedData }
  },
})
